/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { useEffect } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { BuildingType, RandomEvent } from '../types';
import type { ActiveModal } from '../components/UIOverlay';
import { resolvePlayAudio } from '../src/adapters/ui/hooks/useAudio';
import { useGameKeyboard } from './useGameKeyboard';
import { useGameScrollMode } from './useGameScrollMode';

export interface UseGameInputSetupDeps {
  showLanding: boolean;
  gameStarted: boolean;
  activeModal: ActiveModal;
  activeEvent: RandomEvent | null;
  selectedTool: BuildingType;
  selectedTile: { x: number; y: number } | null;
  setActiveModal: (modal: ActiveModal) => void;
  setGameSpeed: Dispatch<SetStateAction<number>>;
  setSelectedTool: Dispatch<SetStateAction<BuildingType>>;
  setSelectedTile: Dispatch<SetStateAction<{ x: number; y: number } | null>>;
}

export function useGameInputSetup(deps: UseGameInputSetupDeps) {
  useEffect(() => () => { resolvePlayAudio({ type: 'stop_ambient' }); }, []);
  useGameScrollMode(deps.showLanding, deps.gameStarted);
  useGameKeyboard(deps);
}